// extracted by mini-css-extract-plugin
export default {"wrapper":"shortcutInstruction_wrapper__1HGqR","instruction_icon":"shortcutInstruction_instruction_icon__T+UQf","instruction_desc":"shortcutInstruction_instruction_desc__EagoK"};